/* ============================================================
   定型キーホルダー 統合注文ページ
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     形状テンプレートデータ（keyholder-standard.js と共通）
  ---------------------------------------------------------- */
  var TEMPLATES = [
    {
      id: 'flower', name: '花形', size: '53×58mm',
      viewBox: [148, 207, 148, 178],
      printAreaPath: 'M212.42,366.73c-4.38,0-8.62-1.56-11.95-4.4l-2.93-2.5c-5.26-4.48-11.67-7.14-18.55-7.68l-3.84-.31c-9.07-.72-16.18-7.83-16.9-16.9l-.31-3.84c-.55-6.88-3.21-13.3-7.68-18.55l-2.5-2.93c-5.9-6.92-5.9-16.98,0-23.9l2.5-2.93c4.48-5.25,7.13-11.67,7.68-18.55l.31-3.84c.72-9.07,7.83-16.18,16.9-16.9l3.84-.31c6.88-.55,13.29-3.21,18.55-7.68l2.93-2.5c3.33-2.84,7.57-4.4,11.95-4.4s8.62,1.56,11.95,4.4l2.93,2.5c5.25,4.48,11.67,7.14,18.55,7.68l3.84.31c9.07.72,16.18,7.83,16.9,16.9l.31,3.84c.55,6.88,3.21,13.3,7.68,18.55l2.5,2.93c5.9,6.92,5.9,16.98,0,23.9l-2.5,2.93c-4.48,5.25-7.13,11.67-7.68,18.55l-.31,3.84c-.72,9.07-7.83,16.18-16.9,16.9l-3.84.31c-6.88.55-13.3,3.21-18.55,7.68l-2.93,2.5c-3.33,2.84-7.57,4.4-11.95,4.4Z',
      cutLinePath: 'M282.47,314.21l-2.5,2.93c-3.48,4.09-5.59,9.17-6.01,14.52l-.31,3.84c-1,12.49-10.91,22.41-23.4,23.4l-3.84.31c-5.35.43-10.43,2.53-14.52,6.01l-2.93,2.5c-9.54,8.13-23.56,8.13-33.09,0l-2.93-2.5c-4.09-3.48-9.17-5.59-14.52-6.01l-3.84-.31c-12.49-1-22.41-10.91-23.4-23.4l-.31-3.84c-.43-5.35-2.53-10.43-6.01-14.52l-2.5-2.93c-8.13-9.54-8.13-23.56,0-33.09l2.5-2.93c3.48-4.09,5.59-9.17,6.01-14.52l.31-3.84c1-12.49,10.91-22.41,23.4-23.4l3.84-.31c5.35-.43,10.43-2.53,14.52-6.01l2.93-2.5c1.27-1.09,2.63-2.02,4.04-2.81,2.13-1.19,3.1-3.66,2.71-6.07-.08-.51-.13-1.04-.13-1.58,0-5.84,5.05-10.51,11.02-9.86,4.57.49,8.28,4.22,8.76,8.79.1.95.07,1.87-.09,2.75-.41,2.37.63,4.79,2.73,5.96,1.41.79,2.77,1.73,4.04,2.81l2.93,2.5c4.09,3.48,9.17,5.59,14.52,6.01l3.84.31c12.49,1,22.41,10.91,23.4,23.4l.31,3.84c.43,5.35,2.53,10.43,6.01,14.52l2.5,2.93c8.13,9.54,8.13,23.56,0,33.09ZM212.42,212.91c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25,4.25-1.9,4.25-4.25-1.9-4.25-4.25-4.25Z',
      hole: { cx: 212.42, cy: 217.16, r: 4.25 },
      center: { x: 212.42, y: 295 }, areaW: 118, areaH: 124
    },
    {
      id: 'circle', name: '円形', size: '50×55mm',
      viewBox: [310, 213, 158, 168],
      printAreaPath: 'M389.04,363.62c-35.17,0-63.78-28.61-63.78-63.78s28.61-63.78,63.78-63.78,63.78,28.61,63.78,63.78-28.61,63.78-63.78,63.78Z',
      cutLinePath: 'M398.78,226.77c.18-.93.23-1.9.13-2.9-.46-4.6-4.19-8.35-8.78-8.84-5.97-.63-11.01,4.03-11.01,9.86,0,.6.05,1.19.16,1.76.28,1.58-.71,3.09-2.3,3.37-34.52,5.95-60.58,36.93-58.71,73.52,1.84,35.98,30.92,65.13,66.9,67.06,40.82,2.18,74.74-30.4,74.74-70.76,0-34.96-25.46-64.07-58.81-69.82-1.54-.26-2.61-1.72-2.32-3.25ZM392.57,224.9c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 389.03, cy: 224.9, r: 3.54 },
      center: { x: 389.04, y: 299.84 }, areaW: 127.56, areaH: 127.56
    },
    {
      id: 'square', name: '正方形', size: '45×50mm',
      viewBox: [474, 213, 138, 162],
      printAreaPath: 'M486.38,241.14h113.39v113.39h-113.39z',
      cutLinePath: 'M604.02,234.06h-49.71c-1.04,0-1.85-.97-1.6-1.98.28-1.13.37-2.34.21-3.59-.57-4.54-4.3-8.19-8.85-8.64-5.93-.58-10.92,4.06-10.92,9.87,0,.78.09,1.53.26,2.26.25,1.05-.49,2.07-1.58,2.07h-49.71c-1.57,0-2.83,1.27-2.83,2.83v121.89c0,1.57,1.27,2.83,2.83,2.83h121.89c1.57,0,2.83-1.27,2.83-2.83v-121.89c0-1.57-1.27-2.83-2.83-2.83ZM546.62,229.73c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 543.08, cy: 229.73, r: 3.54 },
      center: { x: 543.07, y: 297.83 }, areaW: 113.39, areaH: 113.39
    },
    {
      id: 'heart', name: 'ハート形', size: '55×45mm',
      viewBox: [630, 232, 162, 145],
      printAreaPath: 'M711.97,256.34c-1.83,1.13-3.98,1.79-6.29,1.79-.08,0-.15,0-.22-.01-.08,0-.15.01-.22.01-2.31,0-4.46-.66-6.29-1.79-.75-.46-2.42-2.01-2.42-2.01-6.29-5.98-14.3-8.19-22.47-8.74-.09,0-.18-.02-.26-.02-.22-.01-.45-.02-.67-.03-11.49-.59-23.33,4.04-31.18,14.52-5.09,6.79-7.28,14.19-7.33,21.62,0,.11,0,.21,0,.32,0,.24,0,.49,0,.73.04,5.2,1.14,10.27,3.03,15.13,2.72,7.26,7.08,14.12,12.31,19.96,15.4,17.22,36.24,29.45,55.41,41.95.03-.02.07-.04.1-.06.03.02.07.04.1.06,19.17-12.5,40.01-24.73,55.41-41.95,5.23-5.84,9.58-12.7,12.31-19.96,1.89-4.86,3-9.93,3.03-15.13,0-.24,0-.49,0-.73,0-.11,0-.21,0-.32-.06-7.43-2.25-14.83-7.33-21.62-7.85-10.48-19.69-15.12-31.18-14.52-.22,0-.45.01-.67.03-.09,0-.18.02-.26.02-8.17.55-16.18,2.76-22.47,8.74,0,0-1.67,1.55-2.42,2.01Z',
      cutLinePath: 'M774.43,255.82c-1.18-1.58-2.47-3.06-3.83-4.44l-.08-.07c-.64-.64-1.71-1.65-2.38-2.25,0,0,0,0-.01-.01-7.84-6.84-17.87-10.65-28.6-10.65-.79,0-1.58.03-2.36.07-6.85.3-13.36,2.16-19.12,5.34-1.41.78-3.24.27-3.96-1.17-1.63-3.24-4.98-5.46-8.85-5.46s-7.22,2.22-8.85,5.46c-.72,1.44-2.55,1.95-3.96,1.17-5.76-3.18-12.27-5.04-19.12-5.34-.78-.04-1.57-.07-2.36-.07-10.74,0-20.77,3.81-28.6,10.65,0,0,0,0-.01.01-.68.59-1.75,1.61-2.38,2.25l-.08.07c-1.36,1.38-2.64,2.86-3.83,4.44-5.86,7.82-8.81,16.84-8.75,26.47-.04,6.78,1.47,13.67,4.49,20.55,2.95,6.93,7.25,13.69,12.65,19.72,13.94,15.58,31.72,27.01,48.92,38.06,2.65,1.7,5.29,3.4,7.9,5.1,1.21.79,2.59,1.16,3.98,1.14,1.38.02,2.77-.35,3.98-1.14,2.61-1.7,5.25-3.4,7.9-5.1,17.2-11.05,34.99-22.48,48.92-38.06,5.4-6.04,9.71-12.8,12.65-19.72,3.02-6.87,4.53-13.76,4.49-20.55.06-9.63-2.89-18.65-8.75-26.47ZM708.77,247.08c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 705.23, cy: 247.08, r: 3.54 },
      center: { x: 706, y: 305 }, areaW: 138, areaH: 104
    },
    {
      id: 'window', name: '窓形', size: '45×55mm',
      viewBox: [198, 444, 149, 178],
      printAreaPath: 'M221.56,597.5c-.78,0-1.42-.64-1.42-1.42v-83.62c0-27.65,19.9-50.74,46.12-55.71-.04.37-.06.75-.06,1.14,0,5.86,4.77,10.63,10.63,10.63s10.63-4.77,10.63-10.63c0-.38-.02-.76-.06-1.14,26.23,4.97,46.12,28.06,46.12,55.71v83.62c0,.78-.64,1.42-1.42,1.42h-110.55Z',
      cutLinePath: 'M332.11,604.59h-110.55c-4.7,0-8.5-3.81-8.5-8.5v-83.62c0-35.22,28.56-63.78,63.78-63.78h0c35.22,0,63.78,28.56,63.78,63.78v83.62c0,4.7-3.81,8.5-8.5,8.5ZM280.38,461.44c0,1.96-1.59,3.54-3.54,3.54s-3.54-1.59-3.54-3.54,1.59-3.54,3.54-3.54,3.54,1.59,3.54,3.54Z',
      hole: { cx: 276.84, cy: 461.44, r: 3.54 },
      center: { x: 276.84, y: 532 }, areaW: 110, areaH: 138
    },
    {
      id: 'diamond', name: '菱形', size: '40×75mm',
      viewBox: [348, 431, 129, 274],
      printAreaPath: 'M410.18,642.98c-4.96,0-9.46-2.93-11.47-7.47l-35.97-81.53c-2.86-6.49-2.86-13.92,0-20.41l35.97-81.53c.36-.81.79-1.57,1.3-2.27,1.33,4.46,5.39,7.7,10.17,7.7s8.84-3.25,10.17-7.7c.5.7.94,1.46,1.3,2.27l35.97,81.53c2.86,6.49,2.86,13.92,0,20.41l-35.97,81.53c-2,4.54-6.5,7.47-11.47,7.47Z',
      cutLinePath: 'M428.13,449.17l35.97,81.53c3.67,8.32,3.67,17.81,0,26.13l-35.97,81.53c-3.14,7.11-10.18,11.7-17.95,11.7h0c-7.77,0-14.81-4.59-17.95-11.7l-35.97-81.53c-3.67-8.32-3.67-17.81,0-26.13l35.97-81.53c3.14-7.11,10.18-11.7,17.95-11.7h0c7.77,0,14.81,4.59,17.95,11.7ZM410.18,442.78c-1.96,0-3.54,1.7-3.54,3.8s1.59,3.8,3.54,3.8,3.54-1.7,3.54-3.8-1.59-3.8-3.54-3.8Z',
      hole: { cx: 410.18, cy: 446.58, r: 3.8 },
      center: { x: 410.18, y: 548 }, areaW: 82, areaH: 193
    },
    {
      id: 'rectangle', name: '長方形', size: '40×55mm',
      viewBox: [474, 445, 133, 177],
      printAreaPath: 'M490.63,600.12v-129.78c.46.06.94.09,1.42.09,5.86,0,10.63-4.77,10.63-10.63,0-.48-.03-.95-.09-1.42h87.26v141.73h-99.21Z',
      cutLinePath: 'M594.1,607.21h-107.72c-1.57,0-2.83-1.27-2.83-2.83v-150.24c0-1.57,1.27-2.83,2.83-2.83h107.72c1.57,0,2.83,1.27,2.83,2.83v150.24c0,1.57-1.27,2.83-2.83,2.83ZM492.05,463.35c1.96,0,3.54-1.59,3.54-3.54s-1.59-3.54-3.54-3.54c-1.96,0-3.54,1.59-3.54,3.54s1.59,3.54,3.54,3.54Z',
      hole: { cx: 492.05, cy: 459.81, r: 3.54 },
      center: { x: 540, y: 531 }, areaW: 107, areaH: 140
    },
    {
      id: 'stick', name: 'スティック形', size: '23×80mm',
      viewBox: [614, 412, 84, 250],
      printAreaPath: 'M629.8,640.72v-200.64c.46.06.94.09,1.42.09,5.86,0,10.63-4.77,10.63-10.63,0-.48-.03-.95-.09-1.42h39.07v212.6h-51.02Z',
      cutLinePath: 'M685.08,647.8h-59.53c-1.57,0-2.83-1.27-2.83-2.83v-221.1c0-1.57,1.27-2.83,2.83-2.83h59.53c1.57,0,2.83,1.27,2.83,2.83v221.1c0,1.57-1.27,2.83-2.83,2.83ZM631.22,425.99c-1.96,0-3.54,1.59-3.54,3.54s1.59,3.54,3.54,3.54,3.54-1.59,3.54-3.54-1.59-3.54-3.54-3.54Z',
      hole: { cx: 631.22, cy: 429.53, r: 3.54 },
      center: { x: 655, y: 537 }, areaW: 52, areaH: 210
    }
  ];

  /* ----------------------------------------------------------
     初期化
  ---------------------------------------------------------- */
  var root = document.querySelector('.khf');
  if (!root) return;

  var productHandle = root.dataset.product || 'keyholder-fixed';
  var sid = root.dataset.sid || '';

  /* DOM参照 */
  var shapeBtns       = root.querySelectorAll('.khf__shape-btn');
  var shapeBadge      = root.querySelector('#khf-shape-badge');
  var qtyBtns         = root.querySelectorAll('.khf__qty-btn');
  var qtyVal          = root.querySelector('.khf__qty-val');
  var deliveryLabels  = root.querySelectorAll('.khf__delivery-label');
  var deliveryInputs  = root.querySelectorAll('input[name="khf-delivery-' + sid + '"]');
  var methodTabs      = root.querySelectorAll('.khf__method-tab');
  var panels          = root.querySelectorAll('.khf__panel');
  var totalEl         = root.querySelector('#khf-total');
  var cartBtn         = root.querySelector('#khf-btn-cart');

  /* エディター DOM */
  var shapePrompt     = root.querySelector('#khf-shape-prompt');
  var editorEl        = root.querySelector('#khf-editor');
  var sizeBadgeEditor = root.querySelector('#khf-size-badge-editor');
  var svgWrap         = root.querySelector('#khf-svg-wrap');
  var svgEl           = root.querySelector('#khf-svg-el');
  var svgImg          = svgEl ? svgEl.querySelector('image') : null;
  var clipPath        = svgEl ? svgEl.querySelector('clipPath path') : null;
  var cutPath         = svgEl ? svgEl.querySelector('.khf__svg-cut') : null;
  var uploadGuide     = root.querySelector('#khf-upload-guide');
  var fileInput       = root.querySelector('#khf-file-input');
  var controls        = root.querySelector('#khf-controls');
  var sliderScale     = root.querySelector('#khf-slider-scale');
  var sliderX         = root.querySelector('#khf-slider-x');
  var sliderY         = root.querySelector('#khf-slider-y');
  var sliderRotate    = root.querySelector('#khf-slider-rotate');
  var valScale        = root.querySelector('#khf-val-scale');
  var valX            = root.querySelector('#khf-val-x');
  var valY            = root.querySelector('#khf-val-y');
  var valRotate       = root.querySelector('#khf-val-rotate');
  var btnUpload       = root.querySelector('#khf-btn-upload');
  var btnReset        = root.querySelector('#khf-btn-reset');
  var btnConfirm      = root.querySelector('#khf-btn-confirm');
  var donePanel       = root.querySelector('#khf-done');
  var doneCanvasWrap  = root.querySelector('#khf-done-canvas-wrap');
  var attachStrip     = root.querySelector('#khf-attach-strip');
  var attachSelected  = root.querySelector('#khf-attach-selected');
  var btnRedo         = root.querySelector('#khf-btn-redo');

  /* こだわり入稿 DOM */
  var proDropzone     = root.querySelector('#khf-pro-dropzone');
  var proFileInput    = root.querySelector('#khf-pro-file-input');
  var proFileStatus   = root.querySelector('#khf-pro-file-status');
  var proFileName     = root.querySelector('#khf-pro-file-name');
  var proFileRemove   = root.querySelector('#khf-pro-file-remove');
  var proNotesInput   = root.querySelector('#khf-pro-notes-input');

  /* ----------------------------------------------------------
     状態
  ---------------------------------------------------------- */
  var currentTemplate = null;
  var selectedDelivery = '通常便（10営業日出荷）';
  var selectedQuantity = 1;
  var selectedMethod   = 'easy';
  var productVariants  = [];

  /* SVGエディター状態 */
  var state = { tx: 0, ty: 0, scale: 1, rotate: 0 };
  var imgUrl = '';
  var imgNatW = 0, imgNatH = 0;
  var designCanvas = null;

  /* 付属金具 */
  var attachmentOptions = [];
  var selectedAttachment = null;
  var attachDataEl = document.getElementById('khf-attach-data-' + sid);
  if (attachDataEl) {
    try { attachmentOptions = JSON.parse(attachDataEl.textContent); } catch (e) {}
  }
  if (attachmentOptions.length) selectedAttachment = attachmentOptions[0];

  /* こだわり入稿 */
  var proFile = null;
  var proFileUrl = '';

  /* ----------------------------------------------------------
     バリアント取得
  ---------------------------------------------------------- */
  fetch('/products/' + productHandle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      productVariants = data.variants || [];
      updateTotal();
    })
    .catch(function () {});

  /* ----------------------------------------------------------
     ユーティリティ
  ---------------------------------------------------------- */
  function show(el) { if (el) el.classList.remove('is-hidden'); }
  function hide(el) { if (el) el.classList.add('is-hidden'); }

  function parseRange(text) {
    var m = (text || '').replace(/\s/g, '').match(/(\d+)[〜~～](\d+)?/);
    if (!m) return null;
    return { min: parseInt(m[1], 10), max: m[2] ? parseInt(m[2], 10) : Infinity };
  }

  function findVariant(qty, deliveryValue, shapeName) {
    if (!productVariants.length || !qty || qty <= 0) return null;
    var isExpress = deliveryValue.indexOf('特急') !== -1;
    for (var i = 0; i < productVariants.length; i++) {
      var v = productVariants[i];
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      var qtyOk = false, delivOk = false, shapeOk = !shapeName;
      opts.forEach(function (opt) {
        var range = parseRange(opt);
        if (range && qty >= range.min && qty <= range.max) qtyOk = true;
        if (!isExpress && opt.indexOf('通常') !== -1) delivOk = true;
        if (isExpress  && opt.indexOf('特急') !== -1) delivOk = true;
        if (shapeName && opt === shapeName) shapeOk = true;
      });
      if (qtyOk && delivOk && shapeOk) return v;
    }
    return null;
  }

  function updateTotal() {
    if (!totalEl) return;
    var shapeName = currentTemplate ? currentTemplate.name : '';
    var v = findVariant(selectedQuantity, selectedDelivery, shapeName);
    if (!v) {
      /* 形なしでフォールバック */
      v = findVariant(selectedQuantity, selectedDelivery, '');
    }
    if (!v || !v.price) { totalEl.textContent = '—'; return; }
    var unit = Math.round(v.price / 100);
    totalEl.textContent = '¥' + (unit * selectedQuantity).toLocaleString('ja-JP');
  }

  /* ----------------------------------------------------------
     形選択
  ---------------------------------------------------------- */
  function computeEditorViewBox(tpl) {
    var R = 3 / 4;
    var FILL = 0.80;
    var cx = tpl.center.x, cy = tpl.center.y;
    var w = Math.max(tpl.viewBox[2], tpl.areaH * R) / FILL;
    var h = w / R;
    return [cx - w / 2, cy - h / 2, w, h];
  }

  function applyTemplate(tpl) {
    currentTemplate = tpl;
    if (clipPath) clipPath.setAttribute('d', tpl.printAreaPath);
    if (cutPath)  cutPath.setAttribute('d', tpl.cutLinePath);
    var vb = computeEditorViewBox(tpl);
    if (svgEl) svgEl.setAttribute('viewBox', vb.join(' '));
    if (sizeBadgeEditor) sizeBadgeEditor.textContent = tpl.name + ' ' + tpl.size;
    state = { tx: 0, ty: 0, scale: 1, rotate: 0 };
    imgUrl = '';
    imgNatW = 0; imgNatH = 0;
    if (svgImg) {
      svgImg.setAttribute('href', '');
      svgImg.setAttribute('width', '0');
      svgImg.setAttribute('height', '0');
    }
    if (svgWrap) svgWrap.classList.remove('has-image');
    if (uploadGuide) uploadGuide.style.display = '';
    if (controls) controls.classList.remove('is-visible');
    hide(btnReset); hide(btnConfirm);
    if (btnUpload) btnUpload.textContent = '画像を追加';
    show(editorEl);
    if (shapePrompt) shapePrompt.style.display = 'none';
    updateSliders();
    renderImage();
    updateTotal();
  }

  shapeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var shapeId = btn.dataset.shapeId;
      var tpl = null;
      for (var i = 0; i < TEMPLATES.length; i++) {
        if (TEMPLATES[i].id === shapeId || TEMPLATES[i].name === btn.dataset.shapeName) {
          tpl = TEMPLATES[i]; break;
        }
      }
      if (!tpl) return;
      shapeBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (shapeBadge) shapeBadge.textContent = btn.dataset.shapeName + ' ' + btn.dataset.shapeSize;
      applyTemplate(tpl);
    });
  });

  /* ----------------------------------------------------------
     数量
  ---------------------------------------------------------- */
  qtyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.dataset.delta, 10) || 0;
      selectedQuantity = Math.max(1, selectedQuantity + delta);
      if (qtyVal) qtyVal.textContent = selectedQuantity;
      updateTotal();
    });
  });

  /* ----------------------------------------------------------
     納期
  ---------------------------------------------------------- */
  deliveryInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      selectedDelivery = this.value;
      deliveryLabels.forEach(function (lbl) { lbl.classList.remove('is-active'); });
      if (this.closest('.khf__delivery-label')) {
        this.closest('.khf__delivery-label').classList.add('is-active');
      }
      updateTotal();
    });
  });

  /* ----------------------------------------------------------
     入稿方法切り替え
  ---------------------------------------------------------- */
  methodTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var method = tab.dataset.method;
      selectedMethod = method;
      methodTabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      panels.forEach(function (p) {
        if (p.dataset.panel === method) p.classList.remove('is-hidden');
        else p.classList.add('is-hidden');
      });
    });
  });

  /* ----------------------------------------------------------
     SVGエディター
  ---------------------------------------------------------- */
  function updateSliders() {
    if (sliderScale)  sliderScale.value  = state.scale;
    if (sliderX)      sliderX.value      = state.tx;
    if (sliderY)      sliderY.value      = state.ty;
    if (sliderRotate) sliderRotate.value = Math.max(-180, Math.min(180, state.rotate));
    if (valScale)  valScale.textContent  = Math.round(state.scale * 100) + '%';
    if (valX)      valX.textContent      = Math.round(state.tx);
    if (valY)      valY.textContent      = Math.round(state.ty);
    if (valRotate) valRotate.textContent = Math.round(state.rotate) + '°';
  }

  function renderImage() {
    if (!currentTemplate || !imgUrl || !svgEl || !svgImg) return;
    var tpl = currentTemplate;
    var cx = tpl.center.x, cy = tpl.center.y;
    var aw = tpl.areaW,    ah = tpl.areaH;
    var ar = imgNatW / imgNatH;
    var baseW = aw, baseH = aw / ar;
    if (baseH < ah) { baseH = ah; baseW = ah * ar; }
    var w = baseW * state.scale;
    var h = baseH * state.scale;
    var rad = state.rotate * Math.PI / 180;
    var cos = Math.cos(rad), sin = Math.sin(rad);
    var ow = Math.abs(w * cos) + Math.abs(h * sin);
    var oh = Math.abs(w * sin) + Math.abs(h * cos);
    var x = cx - ow / 2 + state.tx;
    var y = cy - oh / 2 + state.ty;
    var tc = 'translate(' + (cx + state.tx) + ',' + (cy + state.ty) + ') rotate(' + state.rotate + ') translate(' + (-w / 2) + ',' + (-h / 2) + ')';
    svgImg.setAttribute('href', imgUrl);
    svgImg.setAttribute('x', '0');
    svgImg.setAttribute('y', '0');
    svgImg.setAttribute('width', w);
    svgImg.setAttribute('height', h);
    svgImg.setAttribute('transform', tc);
  }

  function loadImage(file) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      imgNatW = img.naturalWidth;
      imgNatH = img.naturalHeight;
      imgUrl = url;
      state = { tx: 0, ty: 0, scale: 1, rotate: 0 };
      if (svgWrap) svgWrap.classList.add('has-image');
      if (uploadGuide) uploadGuide.style.display = 'none';
      if (controls) controls.classList.add('is-visible');
      show(btnReset); show(btnConfirm);
      if (btnUpload) btnUpload.textContent = '画像を変更';
      updateSliders();
      renderImage();
    };
    img.src = url;
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      if (this.files[0]) loadImage(this.files[0]);
    });
  }
  if (uploadGuide) {
    uploadGuide.addEventListener('click', function () { if (fileInput) fileInput.click(); });
    uploadGuide.addEventListener('dragover', function (e) {
      e.preventDefault();
      if (!imgUrl) uploadGuide.classList.add('is-dragover');
    });
    uploadGuide.addEventListener('dragleave', function () {
      uploadGuide.classList.remove('is-dragover');
    });
    uploadGuide.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadGuide.classList.remove('is-dragover');
      var file = e.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) loadImage(file);
    });
  }
  if (btnUpload) {
    btnUpload.addEventListener('click', function () { if (fileInput) fileInput.click(); });
  }
  if (btnReset) {
    btnReset.addEventListener('click', function () {
      state = { tx: 0, ty: 0, scale: 1, rotate: 0 };
      updateSliders(); renderImage();
    });
  }

  /* スライダー */
  if (sliderScale) sliderScale.addEventListener('input', function () {
    state.scale = parseFloat(this.value); renderImage(); updateSliders();
  });
  if (sliderX) sliderX.addEventListener('input', function () {
    state.tx = parseFloat(this.value); renderImage(); updateSliders();
  });
  if (sliderY) sliderY.addEventListener('input', function () {
    state.ty = parseFloat(this.value); renderImage(); updateSliders();
  });
  if (sliderRotate) sliderRotate.addEventListener('input', function () {
    state.rotate = parseFloat(this.value); renderImage(); updateSliders();
  });

  /* ドラッグ操作 */
  if (svgWrap && svgEl) {
    var dragging = false;
    var dragPx = 0, dragPy = 0, dragTx = 0, dragTy = 0;
    var activePointers = new Set();
    var pinchStartDist = 0, pinchStartScale = 1, pinchStartAngle = 0, pinchStartRotate = 0;

    function toSvgPt(clientX, clientY) {
      var pt = svgEl.createSVGPoint();
      pt.x = clientX; pt.y = clientY;
      return pt.matrixTransform(svgEl.getScreenCTM().inverse());
    }

    svgWrap.addEventListener('pointerdown', function (e) {
      activePointers.add(e.pointerId);
      if (!imgUrl || activePointers.size > 1) { dragging = false; return; }
      dragging = true;
      var sp = toSvgPt(e.clientX, e.clientY);
      dragPx = sp.x; dragPy = sp.y;
      dragTx = state.tx; dragTy = state.ty;
      svgWrap.setPointerCapture(e.pointerId);
    });

    svgWrap.addEventListener('pointermove', function (e) {
      if (activePointers.size === 2) return;
      if (!dragging || !imgUrl) return;
      var sp = toSvgPt(e.clientX, e.clientY);
      state.tx = dragTx + (sp.x - dragPx);
      state.ty = dragTy + (sp.y - dragPy);
      renderImage(); updateSliders();
    });

    svgWrap.addEventListener('pointerup', function (e) {
      activePointers.delete(e.pointerId);
      dragging = false;
    });
    svgWrap.addEventListener('pointercancel', function (e) {
      activePointers.delete(e.pointerId);
      dragging = false;
    });

    /* ピンチズーム・回転 */
    svgWrap.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        var dx = e.touches[1].clientX - e.touches[0].clientX;
        var dy = e.touches[1].clientY - e.touches[0].clientY;
        pinchStartDist  = Math.hypot(dx, dy);
        pinchStartScale = state.scale;
        pinchStartAngle = Math.atan2(dy, dx) * 180 / Math.PI;
        pinchStartRotate = state.rotate;
      }
    }, { passive: true });

    svgWrap.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var dx = e.touches[1].clientX - e.touches[0].clientX;
        var dy = e.touches[1].clientY - e.touches[0].clientY;
        var dist = Math.hypot(dx, dy);
        state.scale  = Math.max(0.1, Math.min(10, pinchStartScale * dist / pinchStartDist));
        var angle    = Math.atan2(dy, dx) * 180 / Math.PI;
        state.rotate = pinchStartRotate + (angle - pinchStartAngle);
        renderImage(); updateSliders();
      }
    }, { passive: false });

    /* スクロールズーム */
    svgWrap.addEventListener('wheel', function (e) {
      if (!imgUrl) return;
      e.preventDefault();
      var delta = e.deltaY > 0 ? 0.9 : 1.1;
      state.scale = Math.max(0.1, Math.min(10, state.scale * delta));
      renderImage(); updateSliders();
    }, { passive: false });
  }

  /* 確定ボタン */
  if (btnConfirm) {
    btnConfirm.addEventListener('click', function () {
      if (!imgUrl || !currentTemplate || !svgEl) return;
      renderDesignCanvas(function (canvas) {
        designCanvas = canvas;
        if (doneCanvasWrap) {
          doneCanvasWrap.innerHTML = '';
          doneCanvasWrap.appendChild(canvas);
        }
        hide(editorEl);
        show(donePanel);
        buildAttachStrip();
      });
    });
  }

  if (btnRedo) {
    btnRedo.addEventListener('click', function () {
      designCanvas = null;
      hide(donePanel);
      show(editorEl);
    });
  }

  /* ----------------------------------------------------------
     Canvas合成
  ---------------------------------------------------------- */
  function renderDesignCanvas(cb) {
    if (!currentTemplate || !imgUrl) return;
    var tpl = currentTemplate;
    var SIZE = 600;
    var canvas = document.createElement('canvas');
    canvas.width = SIZE; canvas.height = SIZE;
    var ctx = canvas.getContext('2d');

    /* SVGをcanvasサイズに変換するスケール */
    var vb = computeEditorViewBox(tpl);
    var scX = SIZE / vb[2], scY = SIZE / vb[3];

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      /* クリップパスを適用 */
      ctx.save();
      ctx.translate(-vb[0] * scX, -vb[1] * scY);
      ctx.scale(scX, scY);

      var p2d = new Path2D(tpl.printAreaPath);
      ctx.clip(p2d);

      /* 白背景 */
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(-9999, -9999, 19998, 19998);

      /* 画像を描画 */
      var cx = tpl.center.x + state.tx;
      var cy = tpl.center.y + state.ty;
      var ar = img.naturalWidth / img.naturalHeight;
      var bw = tpl.areaW, bh = bw / ar;
      if (bh < tpl.areaH) { bh = tpl.areaH; bw = bh * ar; }
      var w = bw * state.scale, h = bh * state.scale;

      ctx.translate(cx, cy);
      ctx.rotate(state.rotate * Math.PI / 180);
      ctx.drawImage(img, -w / 2, -h / 2, w, h);
      ctx.restore();

      cb(canvas);
    };
    img.src = imgUrl;
  }

  /* ----------------------------------------------------------
     付属金具
  ---------------------------------------------------------- */
  function buildAttachStrip() {
    if (!attachStrip || !attachmentOptions.length) return;
    attachStrip.innerHTML = '';
    attachmentOptions.forEach(function (att, idx) {
      var chip = document.createElement('div');
      chip.className = 'khf__attach-chip' + (idx === 0 ? ' is-active' : '');
      if (att.image) {
        var img = document.createElement('img');
        img.src = att.image;
        img.alt = att.label;
        chip.appendChild(img);
      }
      var lbl = document.createElement('span');
      lbl.className = 'khf__attach-chip-label';
      lbl.textContent = att.label + (att.color ? '（' + att.color + '）' : '');
      chip.appendChild(lbl);
      chip.addEventListener('click', function () {
        selectedAttachment = att;
        attachStrip.querySelectorAll('.khf__attach-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        if (attachSelected) {
          attachSelected.textContent = '選択中: ' + att.label + (att.color ? '（' + att.color + '）' : '');
        }
      });
      attachStrip.appendChild(chip);
    });
    if (attachSelected && attachmentOptions[0]) {
      selectedAttachment = attachmentOptions[0];
      attachSelected.textContent = '選択中: ' + attachmentOptions[0].label + (attachmentOptions[0].color ? '（' + attachmentOptions[0].color + '）' : '');
    }
  }

  /* ----------------------------------------------------------
     こだわり入稿
  ---------------------------------------------------------- */
  if (proDropzone) {
    proDropzone.addEventListener('click', function () { if (proFileInput) proFileInput.click(); });
    proDropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      proDropzone.classList.add('is-dragover');
    });
    proDropzone.addEventListener('dragleave', function () {
      proDropzone.classList.remove('is-dragover');
    });
    proDropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      proDropzone.classList.remove('is-dragover');
      var file = e.dataTransfer.files[0];
      if (file) setProFile(file);
    });
  }
  if (proFileInput) {
    proFileInput.addEventListener('change', function () {
      if (this.files[0]) setProFile(this.files[0]);
    });
  }
  if (proFileRemove) {
    proFileRemove.addEventListener('click', function () {
      proFile = null; proFileUrl = '';
      if (proFileInput) proFileInput.value = '';
      show(proDropzone);
      hide(proFileStatus);
    });
  }

  function setProFile(file) {
    proFile = file;
    if (proFileName) proFileName.textContent = file.name;
    if (proDropzone) proDropzone.style.display = 'none';
    show(proFileStatus);
  }

  /* ----------------------------------------------------------
     Cloudinary アップロード
  ---------------------------------------------------------- */
  var CLOUDINARY_URL    = 'https://api.cloudinary.com/v1_1/dzmofagjd/image/upload';
  var CLOUDINARY_PRESET = 'acrifact-keyholder';

  function uploadToCloudinary(file, cb) {
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLOUDINARY_PRESET);
    fetch(CLOUDINARY_URL, { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) { cb(null, d.secure_url || ''); })
      .catch(function (e) { cb(e, ''); });
  }

  function uploadCanvasToCloudinary(canvas, cb) {
    canvas.toBlob(function (blob) {
      var fd = new FormData();
      fd.append('file', blob, 'design.png');
      fd.append('upload_preset', CLOUDINARY_PRESET);
      fetch(CLOUDINARY_URL, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { cb(null, d.secure_url || ''); })
        .catch(function (e) { cb(e, ''); });
    }, 'image/png');
  }

  /* ----------------------------------------------------------
     カート追加
  ---------------------------------------------------------- */
  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      if (!currentTemplate) {
        alert('Step 1 で形を選んでください。');
        return;
      }
      if (selectedMethod === 'easy') {
        submitEasy();
      } else {
        submitPro();
      }
    });
  }

  function getVariantId() {
    var shapeName = currentTemplate ? currentTemplate.name : '';
    var v = findVariant(selectedQuantity, selectedDelivery, shapeName);
    if (!v) v = findVariant(selectedQuantity, selectedDelivery, '');
    return v ? v.id : (productVariants[0] ? productVariants[0].id : null);
  }

  function doAddToCart(variantId, properties) {
    if (!variantId) {
      alert('バリアントが見つかりませんでした。管理者にお問い合わせください。');
      if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = 'カートに追加'; }
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: selectedQuantity, properties: properties }] })
    })
    .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function () { window.location.href = '/cart'; })
    .catch(function () {
      alert('カートへの追加に失敗しました。もう一度お試しください。');
      if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = 'カートに追加'; }
    });
  }

  function submitEasy() {
    if (!designCanvas) {
      alert('「この配置で確定」ボタンを押してから注文してください。');
      return;
    }
    var variantId = getVariantId();
    cartBtn.disabled = true;
    cartBtn.textContent = 'アップロード中...';

    var att = selectedAttachment;
    var props = {
      '入稿方法': 'かんたん入稿',
      'キーホルダーサイズ': currentTemplate ? currentTemplate.size : '',
      'キーホルダーの形': currentTemplate ? currentTemplate.name : '',
      '付属金具': att ? att.label + (att.color ? '（' + att.color + '）' : '') : '未選択',
      '納期': selectedDelivery
    };

    uploadCanvasToCloudinary(designCanvas, function (err, url) {
      if (err) {
        alert('画像のアップロードに失敗しました。もう一度お試しください。');
        cartBtn.disabled = false; cartBtn.textContent = 'カートに追加';
        return;
      }
      if (url) props['_デザインプレビュー'] = url;
      doAddToCart(variantId, props);
    });
  }

  function submitPro() {
    if (!proFile) {
      alert('入稿ファイルを選択してください。');
      return;
    }
    var variantId = getVariantId();
    cartBtn.disabled = true;
    cartBtn.textContent = 'アップロード中...';

    var notes = proNotesInput ? proNotesInput.value.trim() : '';
    var props = {
      '入稿方法': 'こだわり入稿',
      'キーホルダーサイズ': currentTemplate ? currentTemplate.size : '',
      'キーホルダーの形': currentTemplate ? currentTemplate.name : '',
      '納期': selectedDelivery
    };
    if (notes) props['備考'] = notes;

    uploadToCloudinary(proFile, function (err, url) {
      if (err) {
        alert('ファイルのアップロードに失敗しました。もう一度お試しください。');
        cartBtn.disabled = false; cartBtn.textContent = 'カートに追加';
        return;
      }
      if (url) props['_入稿ファイル'] = url;
      doAddToCart(variantId, props);
    });
  }

})();
